export default "__VITE_ASSET__c9873edb__"